import { Link, Radio } from '@nimbus-ds/components';
import { AddressingConfigurationRuleResponseDto } from '@tiendanube/common';
import { Stack } from '@tiendanube/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import {
  ADDRESSING_RULES_TRANSLATE_TYPES,
  ADDRESSING_RULES_TYPES,
  AddressingRuleGroupType,
  AddressingRuleType,
} from '../../constants';
import { findRuleByType } from '../../utils';

interface RuleSelectorProps {
  type: AddressingRuleGroupType;
  rules: AddressingConfigurationRuleResponseDto[];
  isDisabled?: boolean;
  handleChangeRule: (
    checked: boolean,
    type: AddressingRuleType,
    appCode?: string,
  ) => void;
  openLocationsPriorityModal?: () => void;
}

function RuleSelector({
  type,
  rules,
  isDisabled = false,
  handleChangeRule,
  openLocationsPriorityModal,
}: Readonly<RuleSelectorProps>) {
  const t = useTranslationShipping(
    'deliveryMethods.addressingConfigurationV2.types',
  );

  const rulesToRender = rules
    .filter((rule) => {
      if (type === 'materialize') {
        return rule.type === ADDRESSING_RULES_TYPES.MATERIALIZE;
      }
      if (type === 'tiebreaker') {
        return (
          rule.type === ADDRESSING_RULES_TYPES.CD_PRIORITY ||
          rule.type === ADDRESSING_RULES_TYPES.CD_PROXIMITY
        );
      }
      return rule.type === ADDRESSING_RULES_TYPES.APP;
    })
    .sort((a, b) => {
      if (a.type === ADDRESSING_RULES_TYPES.CD_PROXIMITY) {
        return -1;
      }
      if (b.type === ADDRESSING_RULES_TYPES.CD_PROXIMITY) {
        return 1;
      }
      return 0;
    });

  const materializeRuleEnabled = findRuleByType(
    rules,
    ADDRESSING_RULES_TYPES.MATERIALIZE,
  )?.enabled;

  return (
    <>
      {rulesToRender.map((rule) => (
        <Stack align="center" spacing="extra-tight" key={rule.code}>
          <Radio
            key={rule.code}
            name={rule.code}
            label={
              ADDRESSING_RULES_TYPES && rule.appName
                ? rule.appName
                : `${t(`${ADDRESSING_RULES_TRANSLATE_TYPES[rule.type]}`)}${
                    ADDRESSING_RULES_TYPES.CD_PRIORITY ? `.` : ''
                  }` || ''
            }
            checked={rule.enabled}
            disabled={isDisabled}
            onChange={(e) =>
              handleChangeRule(
                e.target.checked,
                rule.type as AddressingRuleType,
                rule.code,
              )
            }
          />
          {rule.type === ADDRESSING_RULES_TYPES.CD_PRIORITY && (
            <Stack align="center" spacing="extra-tight">
              <Link
                as="button"
                appearance="primary"
                onClick={() => {
                  openLocationsPriorityModal?.();
                }}
              >
                Configurar
              </Link>
            </Stack>
          )}
        </Stack>
      ))}

      {type === 'materialize' && (
        <Stack
          align="center"
          spacing="extra-tight"
          key="withoutMaterialization"
        >
          <Radio
            name="withoutMaterialization"
            checked={!materializeRuleEnabled}
            label={t('withoutMaterialize')}
            onChange={(e) =>
              handleChangeRule(
                !e.target.checked,
                ADDRESSING_RULES_TYPES.MATERIALIZE,
              )
            }
          />
        </Stack>
      )}
    </>
  );
}

export default RuleSelector;
